// Comparison analysis
// tanstack
import { createFileRoute } from '@tanstack/react-router';

// feature-components
import EnergyTreeNodeComparisonAnalysisPage from '@/features/energyxplorer/components/analysis/EnergyTreeNodeComparisonAnalysisPage';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/comparison-analysis',
)({
  component: EnergyTreeNodeComparisonAnalysisPage,
  staticData: { crumb: 'energyxplorer:app_bar.energy_analysis_compare' },
});
